var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "all-orders" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "status-tabs" },
          [
            _c("span", { staticClass: "status-tabs-label" }, [
              _vm._v("订单状态:"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.statusTabs, function (tab) {
              return _c(
                "span",
                {
                  key: tab.value,
                  staticClass: "status-tab",
                  class: {
                    active:
                      _vm.activeStatus === tab.value ||
                      (tab.value === "已入库" &&
                        (_vm.activeStatus === "部分入库" ||
                          _vm.activeStatus === "全部入库")),
                  },
                  on: {
                    mouseenter: function ($event) {
                      tab.value === "已入库"
                        ? (_vm.showStockInDropdown = true)
                        : null
                    },
                    click: function ($event) {
                      return _vm.handleStatusTabClick(tab.value)
                    },
                  },
                },
                [
                  _vm._v(_vm._s(tab.label)),
                  tab.value !== null && tab.count > 0
                    ? _c("sup", { staticClass: "tab-badge" }, [
                        _vm._v(_vm._s(tab.count)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  tab.value === "已入库" && _vm.showStockInDropdown
                    ? _c(
                        "div",
                        {
                          staticClass: "status-dropdown",
                          on: {
                            mouseenter: function ($event) {
                              _vm.showStockInDropdown = true
                            },
                            mouseleave: function ($event) {
                              _vm.showStockInDropdown = false
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "status-dropdown-item",
                              class: {
                                "dropdown-active":
                                  _vm.activeStatus === "部分入库",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleStatusTabClick("部分入库")
                                },
                              },
                            },
                            [_vm._v("部分入库")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "status-dropdown-item",
                              class: {
                                "dropdown-active":
                                  _vm.activeStatus === "全部入库",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleStatusTabClick("全部入库")
                                },
                              },
                            },
                            [_vm._v("全部入库")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { model: _vm.searchForm, "label-width": "100px" },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "合同号" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.searchForm.contractNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "contractNo", $$v)
                                },
                                expression: "searchForm.contractNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户姓名" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.searchForm.custName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "custName", $$v)
                                },
                                expression: "searchForm.custName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户电话" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.searchForm.customerPhone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "customerPhone", $$v)
                                },
                                expression: "searchForm.customerPhone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户地址" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.searchForm.custAddress,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "custAddress", $$v)
                                },
                                expression: "searchForm.custAddress",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订单号" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.searchForm.productionOrder,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "productionOrder",
                                    $$v
                                  )
                                },
                                expression: "searchForm.productionOrder",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "经销商" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              model: {
                                value: _vm.searchForm.dealer,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "dealer", $$v)
                                },
                                expression: "searchForm.dealer",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "计划交货日期" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "date",
                                placeholder: "请输入",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.searchForm.scheduledDeliveryDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "scheduledDeliveryDate",
                                    $$v
                                  )
                                },
                                expression: "searchForm.scheduledDeliveryDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "入库日期" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "date",
                                placeholder: "请输入",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.searchForm.stockInDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "stockInDate", $$v)
                                },
                                expression: "searchForm.stockInDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "10px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.searchLoading },
                    on: { click: _vm.handleSearch },
                  },
                  [
                    _c("i", { staticClass: "el-icon-search" }),
                    _vm._v(" 搜索\n        "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { plain: "" }, on: { click: _vm.resetSearch } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider-line" }),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { margin: "10px 0" } },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.hasAnySelection,
                },
                on: { click: _vm.handleDeliveryInstruction },
              },
              [_vm._v("部分发货")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            attrs: {
              "element-loading-text": "加载中...",
              "element-loading-background": "rgba(255,255,255,0.85)",
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "dataTable",
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  "font-size": "13px",
                },
                attrs: {
                  data: _vm.dataList,
                  "max-height": _vm.tableHeight,
                  "header-cell-style": {
                    backgroundColor: "#e8eaed",
                    color: "#333",
                    fontWeight: "bold",
                  },
                  border: "",
                  "row-key": "_rowKey",
                },
                on: { "row-click": _vm.handleRowClick },
              },
              [
                _c(
                  "el-table-column",
                  {
                    attrs: { width: "50", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                value: _vm.isParentChecked(scope.row),
                                indeterminate: _vm.isParentIndeterminate(
                                  scope.row
                                ),
                                disabled: _vm.isParentDisabled(scope.row),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleParentCheckChange(scope.row)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            value: _vm.isAllChecked,
                            indeterminate: _vm.isAllIndeterminate,
                          },
                          on: { change: _vm.handleSelectAll },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { type: "expand" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.contractList &&
                          scope.row.contractList.length > 0
                            ? _c(
                                "div",
                                { staticClass: "nested-table-wrapper" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: {
                                        width: "15.2%",
                                        "font-size": "13px",
                                      },
                                      attrs: {
                                        data: scope.row.contractList,
                                        size: "small",
                                        "header-cell-style": {
                                          backgroundColor: "#e8eaed",
                                          color: "#333",
                                          fontWeight: "bold",
                                        },
                                        border: "",
                                        "row-key": "_rowKey",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: { width: "50", align: "center" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("el-checkbox", {
                                                    attrs: {
                                                      value: _vm.isChildChecked(
                                                        row.row
                                                      ),
                                                      disabled:
                                                        row.row.isAll !==
                                                          "是" ||
                                                        row.row.isInitiate !=
                                                          null,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleChildCheckChange(
                                                          row.row,
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "solutionName",
                                          label: "生产方案",
                                          width: "120",
                                          align: "center",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "状态",
                                          width: "90",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type:
                                                          row.row.isInitiate !=
                                                          null
                                                            ? "success"
                                                            : "info",
                                                        size: "mini",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row.isInitiate !=
                                                            null
                                                            ? "已推送"
                                                            : "未推送"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "是否齐套",
                                          width: "90",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type:
                                                          row.row.isAll === "是"
                                                            ? "success"
                                                            : "warning",
                                                        size: "mini",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row.isAll === "是"
                                                            ? "已齐套"
                                                            : "未齐套"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "area",
                                          label: "面积",
                                          width: "80",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.area || "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "vol",
                                          label: "体积",
                                          width: "80",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.vol != null
                                                          ? row.row.vol
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "packages",
                                          label: "总包数",
                                          width: "80",
                                          align: "center",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "inPackages",
                                          label: "入库数",
                                          width: "80",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.inPackages !=
                                                          null
                                                          ? row.row.inPackages
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "未入数",
                                          width: "80",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.packages !=
                                                          null &&
                                                          row.row.inPackages !=
                                                            null
                                                          ? row.row.packages -
                                                              row.row.inPackages
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "warehouse",
                                          label: "仓库",
                                          width: "100",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.warehouse || "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "库位",
                                          width: "100",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (row) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.location || "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", "min-width": "150", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "pending-action-btn",
                              staticStyle: { color: "#409EFF" },
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$message.info("功能未开发")
                                },
                              },
                            },
                            [_vm._v("图纸")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "pending-action-btn",
                              staticStyle: { color: "#409EFF" },
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$message.info("功能未开发")
                                },
                              },
                            },
                            [_vm._v("BOM")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "pending-action-btn",
                              staticStyle: { color: "#409EFF" },
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$message.info("功能未开发")
                                },
                              },
                            },
                            [_vm._v("模型")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm._l(_vm.tableColumns, function (col) {
                  return _c("el-table-column", {
                    key: col.prop,
                    attrs: {
                      prop: col.prop,
                      label: col.label,
                      "min-width": col.minWidth || 120,
                      align: col.align || "center",
                      "show-overflow-tooltip": !(
                        col.prop === "color" || col.prop === "stoneColor"
                      ),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  style:
                                    col.prop === "color" ||
                                    col.prop === "stoneColor"
                                      ? "white-space: pre-line"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formatCellValue(scope.row, col))
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单详情",
            visible: _vm.detailVisible,
            width: _vm.dialogWidth,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detailRow
            ? _c(
                "el-descriptions",
                { attrs: { column: 3, border: "", size: "medium" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "合同号" } }, [
                    _vm._v(_vm._s(_vm.detailRow.contractNo || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                    _vm._v(_vm._s(_vm.detailRow.orderNo || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "经销商" } }, [
                    _vm._v(_vm._s(_vm.detailRow.dealerShopName || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "客户姓名" } }, [
                    _vm._v(_vm._s(_vm.detailRow.custName || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "电话" } }, [
                    _vm._v(_vm._s(_vm.detailRow.custMobile || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "客户地址" } }, [
                    _vm._v(_vm._s(_vm.detailRow.custAddress || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "合同金额" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detailRow.amount != null
                          ? "¥" + _vm.formatMoney(_vm.detailRow.amount)
                          : "-"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "实收金额" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detailRow.amountReceived != null
                          ? "¥" + _vm.formatMoney(_vm.detailRow.amountReceived)
                          : "-"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "柜数" } }, [
                    _vm._v(_vm._s(_vm.detailRow.volume || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "签单日期" } }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.detailRow.signingTime))),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "下单人" } }, [
                    _vm._v(_vm._s(_vm.detailRow.createUserName || "-")),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "下单时间" } }, [
                    _vm._v(
                      _vm._s(_vm.formatDate(_vm.detailRow.orderClerkTime))
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }